import * as GLOBAL from "../data/global.js";

export default class ConsommationServices {

    static getConsommations() {
        return fetch(`${global.SERVER_ADDRESS}/consommation`)
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static addConsommation(consommation) {
        return fetch(`${global.SERVER_ADDRESS}/consommation`, {
            method: 'POST',
            body: JSON.stringify(consommation),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static updateConsommation(consommation) {
        return fetch(`${global.SERVER_ADDRESS}/consommation/${consommation.id}`, {
            method: 'PUT',
            body: JSON.stringify(consommation),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static deleteConsommation(consommation) {
        return fetch(`${global.SERVER_ADDRESS}/consommation/${consommation.id}`, {
            method: 'DELETE',
            body: JSON.stringify(consommation),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static handleError(error) {
        console.log(error);
    }

}